import {
  FETCH_NOTICE_STATUS,
  FETCH_NOTICE_STATUS_SUCCESS,
  FETCH_NOTICE_STATUS_FAIL,
  RESET_NOTICE_STATUS
} from '../actions/types'

const INITIAL_STATE = {
  loading: true,
  data: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FETCH_NOTICE_STATUS:
      return { ...state, loading: true }
    case FETCH_NOTICE_STATUS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false
      }
    case FETCH_NOTICE_STATUS_FAIL:
      return { ...state, loading: false }
    case RESET_NOTICE_STATUS:
      return INITIAL_STATE
    default:
      return (state)
  }
}
